import { Loader } from "@/components/loader";
import { Box, Grid, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getActiveAreaId, getListOfAdvices } from "../../../../api/area";
import TableUserDrug from "./tableUserDrug";

export default function DrugTableArea() {
  const [notDeliveredDataUser, setNotDeliveredDataUser] = useState();
  const [deliveredDataUser, setDeliveredDataUser] = useState();

  const [loading, setLoading] = useState(false);
  const [areaId, setAreaId] = useState();

  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalSize, setTotalSize] = useState();

  const [pageableNotDelivered, setPageableNotDelivered] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalSizeNotDelivered, setTotalSizeNotDelivered] = useState();

  const [lastFetch, setLastFetch] = useState();
  const [notDeliveredLastFetch, setNotDeliveredLastFetch] = useState();

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  const fetchDataNotDelivered = useCallback(() => {
    if (
      notDeliveredLastFetch !== undefined &&
      Date.now() - notDeliveredLastFetch < 500
    )
      return;

    const query = new URLSearchParams();
    query.append("pageIndex", pageableNotDelivered.pageIndex);
    query.append("pageSize", pageableNotDelivered.pageSize);

    if (totalSizeNotDelivered === undefined)
      query.append("neededTotalSize", true);

    setLoading(true);

    query.append("deliveryStatus", "NOT_DELIVERED");
    getListOfAdvices(areaId, query.toString())
      .then((x) => {
        setNotDeliveredDataUser(x.content);
        if (totalSizeNotDelivered === undefined)
          setTotalSizeNotDelivered(x.totalElements);
      })
      .catch(() => {})
      .finally(() => {
        setNotDeliveredLastFetch(Date.now());
        setLoading(false);
      });
  }, [areaId, pageableNotDelivered, totalSizeNotDelivered]);

  const fetchDataDelivered = useCallback(() => {
    if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;
    const query = new URLSearchParams();
    query.append("pageIndex", pageable.pageIndex);
    query.append("pageSize", pageable.pageSize);

    if (totalSize === undefined) query.append("neededTotalSize", true);

    setLoading(true);

    query.append("deliveryStatus", "DELIVERED");
    getListOfAdvices(areaId, query.toString())
      .then((x) => {
        setDeliveredDataUser(x.content);
        if (totalSize === undefined) setTotalSize(x.totalElements);
      })
      .catch(() => {})
      .finally(() => {
        setLastFetch(Date.now());
        setLoading(false);
      });
  }, [areaId, pageable]);

  useEffect(() => {
    if (areaId) {
      fetchDataDelivered();
    }
  }, [areaId, pageable]);

  useEffect(() => {
    if (areaId) {
      fetchDataNotDelivered();
    }
  }, [areaId, pageableNotDelivered]);

  const md = useMediaQuery("(max-width:450px)");
  const navigate = useNavigate();

  return (
    <>
      {loading && <Loader />}
      <Box>
        <Grid display={"flex"} flexDirection={"column"} gap={"50px"}>
          {deliveredDataUser && (
            <>
              <TableUserDrug
                pageable={pageable}
                setPageable={setPageable}
                totalSize={totalSize}
                rowData={deliveredDataUser}
                areaId={areaId}
              />
              <TableUserDrug
                pageable={pageableNotDelivered}
                setPageable={setPageableNotDelivered}
                totalSize={totalSizeNotDelivered}
                areaId={areaId}
                rowData={notDeliveredDataUser}
                notDelivered
              />
            </>
          )}
        </Grid>
      </Box>
    </>
  );
}
